import { render, staticRenderFns } from "./PlatformInfoTopNew.vue?vue&type=template&id=1a6959ba&scoped=true"
import script from "./PlatformInfoTopNew.vue?vue&type=script&lang=js"
export * from "./PlatformInfoTopNew.vue?vue&type=script&lang=js"
import style0 from "./PlatformInfoTopNew.vue?vue&type=style&index=0&id=1a6959ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6959ba",
  null
  
)

export default component.exports